/** Only addresses inside the app ("/work/123"); never "//host" or "http…". */
export const isInAppLink = (link?: string | null): link is string => {
  if (typeof link !== "string") return false;
  const value = link.trim();
  return (
    value.startsWith("/") &&
    !value.startsWith("//") &&
    !value.includes("\\") &&
    !/\s/.test(value) &&
    !Array.from(value).some((char) => char.charCodeAt(0) < 32)
  );
};
